//拦截写在request里
import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import enLocale from "element-ui/lib/locale/lang/en"; //导入element ui中的默认英文配置
import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //导入element ui中的默认中文配置
import esLocale from "element-ui/lib/locale/lang/es"; //导入element ui中的默认中文配置
import jaLocale from "element-ui/lib/locale/lang/ja"; //导入element ui中的默认中文配置
import Cookies from "js-cookie";
import App from "./App";
import { requestData } from "./request/request.js";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
// 引入字体样式
import "./assets/fonts/text.css";

import zh from "./lang/zh";
import en from "./lang/en";
import sp from "./lang/sp";
import ja from "./lang/ja";
// echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import VueDND from "awe-dnd";
Vue.use(VueDND);
// i18n
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh",
  messages: {
    zh: {
      ...zh,
      ...zhLocale,
    },
    en: {
      ...en,
      ...enLocale,
    },
    ja: {
      ...ja,
      ...jaLocale,
    },
    sp: {
      ...sp,
      ...esLocale,
    },
  },
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

import store from "./store";
import Routers from "./router.js";
//引入动画
// import wow from "wowjs";
// import "wowjs/css/libs/animate.css";
// Vue.prototype.$wow = wow;
// 引入animate.css
import "animate.css";
// import animated from 'wowjs/css/libs/animate.css';//不需要后期修改动画可以直接使用该代码
import animated from "./assets/css/animate.css";
//这里需要将样式用起来，
Vue.use(animated);

Vue.prototype.request = requestData;
// 定义获取uuid的方法
Vue.prototype.$generateUUID = function () {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  uuid = uuid.replace(/-/g, "");
  return uuid;
};

new Vue({
  el: "#app",
  router: Routers,
  i18n,
  store,
  components: {
    App,
  },
  template: "<App/>",
});
// 注入

if (process.env.NODE_ENV === "production") {
  // 生产环境下(懒得找了，直接把console清了)
  window.console.log = function () {};
}



// WEBPACK FOOTER //
// ./src/main.js